// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__d6PpB","content":"styles_content__9ekzR"};